import { cacheTypes, getMethodByCallBack, serverUrl, getheader, getMethodByDispatcher, postMethod, postMethodByCallBack } from "./CommonFunctions";
export function getSystemSettings(data) {
    let token = localStorage.getItem("token");
    let sUrl = localStorage.getItem("ServerUrl");
    if (!token || !sUrl) {
        return dispatch => {
            dispatch({
                type: "GET_SYSTEM_SETTINGS",
                data: []
            });
        }
    }
    return dispatch => {
        fetch(sUrl + "api/SystemSetting/GetSystemSettings", {
            headers: getheader(),
            body: JSON.stringify(data),
            method: "POST",
            cache: "default"
        }).then(res => res.json())
            .then(res => {
                if (res.Message === "Error") {
                    res = [];
                }
                return dispatch({
                    type: "GET_SYSTEM_SETTINGS",
                    data: res
                });
            }).catch(e => {
                console.log("[GET_SYSTEM_SETTINGS] ", e);
                return dispatch({
                    type: "GET_SYSTEM_SETTINGS",
                    data: []
                })
            });
    }
}
/**
 * 
 * @param {string[]} settingNames 
 * @returns 
 */
export function getSystemSettingsByCallback(settingNames, setSettings) {
    postMethodByCallBack("api/SystemSetting/GetSystemSettings", settingNames, setSettings,"GetSystemSettings");
}
export async function getSystemSettingsAsync(settingNames) {
   const result =  postMethod("api/SystemSetting/GetSystemSettings", settingNames, "GetSystemSettings");
   return result;
}
export function getPrintTemplate(templateName) {
    return dispatch => {
        dispatch({
            type: "GET_PRINT_TEMPLATE",
            data: "PENDING"
        });
        fetch(serverUrl + "api/PrintTemplateAPI/GetTemplate?templateName=" + templateName, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res === "Error" || res.Message) {
                    res = null;
                }
                dispatch({
                    type: "GET_PRINT_TEMPLATE",
                    data: res
                });
            })
    }
}
export function setPrintViewerPopStatus(status) {
    return dispatch => {
        dispatch({
            type: "PRINT_VIEW_POPSTATUS",
            data: status
        });
    }
}
export function checkSystemVersion(onGet) {
    getMethodByCallBack("api/SystemSetting/CheckSystemVersion", cacheTypes.Default, onGet, "CHECK_VERSION");
}
export function getAppConfig() {
        return getMethodByDispatcher("api/SystemSetting/GetAppConfig", "GET_APP_CONFIG", cacheTypes.Default, "");
}